import { render, staticRenderFns } from "./BusinessInfoTab.vue?vue&type=template&id=b475e08e&scoped=true"
import script from "./BusinessInfoTab.vue?vue&type=script&lang=js"
export * from "./BusinessInfoTab.vue?vue&type=script&lang=js"
import style0 from "./BusinessInfoTab.vue?vue&type=style&index=0&id=b475e08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b475e08e",
  null
  
)

export default component.exports